<div class="ddp-wrap-option-slider">
  <span class="ddp-label-slider" style="width: 100px; display: block">{{ label }}</span>
  <div class="ddp-checkbox-slide ddp-checkbox-automatic2" [class.ddp-disabled]="disabled">
    <input type="checkbox" [disabled]="disabled" [value]="value" [attr.checked]="checked || undefined" />
    <label><span class="ddp-slide"></span></label>
  </div>
</div>
